<template>
  <div class="creation-center page">
    <el-container class="h-screen flex flex-col">
      <el-header class="border-b border-gray-700 flex justify-between gap-x-5 items-center px-4 md:px-6 py-3 md:p-8 h-auto">
        <!-- logo-->
        <div class="p-2 md:p-4 flex items-center justify-center">
          <img src="@/assets/img/logo.jpg" alt="LaplaceMate" class="h-8 md:h-12 object-contain" />
        </div>

        <!-- 移动端菜单按钮 -->
        <el-button
            icon="el-icon-menu"
            class="md:hidden text-white bg-transparent border-none"
            @click="toggleSidebar"
        ></el-button>

        <div class="hidden md:flex items-center gap-x-4 md:gap-x-10">
<!--          <div class="text-white text-sm md:text-xl">{{ $t('home.home') }}</div>-->
<!--          <div class="text-white text-sm md:text-xl">{{ $t('home.modelCommunity') }}</div>-->
          <div class="text-white text-sm md:text-xl cursor-pointer hover:text-blue-400 transition-colors" @click="handleCreationCenterClick">{{ $t('home.creationCenter') }}</div>
          <el-dropdown @command="handleCommand" trigger="click">
            <el-avatar src="https://picsum.photos/id/64/40/40" class="cursor-pointer w-8 h-8 md:w-10 md:h-10"></el-avatar>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="logout">
                <i class="el-icon-switch-button"></i>
                <span style="margin-left: 8px;">退出登录</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-header>

      <el-container class="flex-1 flex overflow-hidden">
        <!-- 侧边栏 - 在移动端可折叠 -->
        <el-aside
            :width="sidebarWidth"
            style="background-color:#333A53; transition: width 0.3s ease"
            :class="{ 'hidden': !sidebarVisible && isMobile }"
        >
          <el-menu
              :default-active="$route.path"
              class="bg-transparent border-none text-gray-300 pl-3 pr-3 md:pl-5 md:pr-5"
              text-color="#ccc"
              active-text-color="#fff"
              background-color="transparent"
              router
              :collapse="sidebarCollapsed && !isMobile"
              :collapse-transition="false"
          >
            <!-- 普通用户菜单 -->
            <template v-if="!isAdmin">
              <el-menu-item index="/home/createRole" class="menu-item-content">
                <i class="el-icon-house menu-icon"></i>
                <span slot="title">{{ $t('home.createNewCharacter') }}</span>
              </el-menu-item>
              <el-menu-item index="/home/myModels" class="menu-item-content">
                <i class="el-icon-user menu-icon"></i>
                <span slot="title">{{ $t('home.myRoleLibrary') }}</span>
              </el-menu-item>
<!--              <el-menu-item index="/home/friends" class="menu-item-content">-->
<!--                <image src="@/assets/img/friends.png" class="menu-icon" />-->
<!--                <span slot="title">-->
<!--                  {{ $t('home.myFriends') }}-->
<!--                  <el-badge class="ml-2" value="8"/>-->
<!--                </span>-->
<!--              </el-menu-item>-->
              <el-menu-item index="/home/voiceModels" class="menu-item-content">
                <i class="el-icon-microphone menu-icon"></i>
                <span slot="title">{{ $t('home.llmModel') }}</span>
              </el-menu-item>
              <el-menu-item index="/home/voiceSetting" class="menu-item-content">
                <i class="el-icon-office-building menu-icon"></i>
                <span slot="title">{{ $t('home.voiceSettings') }}</span>
              </el-menu-item>
              <el-menu-item index="/home/myVoiceLibrary" class="menu-item-content">
                <i class="el-icon-headset menu-icon"></i>
                <span slot="title">{{ $t('home.myVoiceLibrary') }}</span>
              </el-menu-item>
<!--              <el-menu-item index="/home/roomDesign" class="menu-item-content">-->
<!--                <i class="el-icon-video-camera menu-icon"></i>-->
<!--                <span slot="title">{{ $t('home.roomDesign') }}</span>-->
<!--              </el-menu-item>-->
<!--              <el-menu-item index="/home/action" class="menu-item-content">-->
<!--                <i class="el-icon-video-camera menu-icon"></i>-->
<!--                <span slot="title">{{ $t('home.actionLibrary') }}</span>-->
<!--              </el-menu-item>-->
            </template>

            <!-- 管理员菜单 -->
            <template v-else>
              <el-menu-item index="/home/systemRoles" class="menu-item-content">
                <i class="el-icon-video-camera menu-icon"></i>
                <span slot="title">{{ $t('home.systemRoleSettings') }}</span>
              </el-menu-item>
              <el-menu-item index="/home/voiceSettings" class="menu-item-content">
                <i class="el-icon-microphone menu-icon"></i>
                <span slot="title">{{ $t('home.voiceSettings') }}</span>
              </el-menu-item>
              <el-menu-item index="/home/systemParam" class="menu-item-content">
                <i class="el-icon-setting menu-icon"></i>
                <span slot="title">{{ $t('home.systemParam') }}</span>
              </el-menu-item>
              <el-menu-item index="/home/usageLog" class="menu-item-content">
                <i class="el-icon-document menu-icon"></i>
                <span slot="title">{{ $t('home.usageLog') }}</span>
              </el-menu-item>
            </template>
          </el-menu>
        </el-aside>

        <!-- 主内容区域 -->
        <el-main class="flex-1 p-0 md:p-4 overflow-auto">
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
export default {
  name: 'HomePage',
  computed: {
    // 是否为管理员
    isAdmin() {
      return this.$store.state.isAdmin
    }
  },
  data() {
    return {
      sidebarVisible: true,    // 侧边栏是否可见（移动端）
      sidebarCollapsed: false, // 侧边栏是否折叠（桌面端）
      isMobile: false,         // 是否为移动设备
      sidebarWidth: '288px'    // 侧边栏宽度
    }
  },
  created() {
    // 初始化判断设备类型
    this.checkDeviceType();
    // 监听窗口大小变化
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    // 移除事件监听
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    // 检查设备类型
    checkDeviceType() {
      this.isMobile = window.innerWidth < 768;
      // 移动端默认隐藏侧边栏
      if (this.isMobile) {
        this.sidebarVisible = false;
      } else {
        this.sidebarVisible = true;
      }
    },
    // 处理窗口大小变化
    handleResize() {
      const isMobile = window.innerWidth < 768;
      // 设备类型变化时更新状态
      if (isMobile !== this.isMobile) {
        this.isMobile = isMobile;
        this.sidebarVisible = !isMobile;
        this.sidebarCollapsed = false;
      }
    },
    // 切换侧边栏显示/隐藏（移动端）
    toggleSidebar() {
      this.sidebarVisible = !this.sidebarVisible;
    },
    // 点击创作中心调用SSO
    async handleCreationCenterClick() {
      try {
        // 获取当前用户ID，并转为字符串
        const user = this.$store.state.user || JSON.parse(sessionStorage.getItem('user') || 'null');
        const userId = this.$store.state.userId || sessionStorage.getItem('userId') || (user && user.id ? String(user.id) : null);
        
        if (!userId) {
          this.$message.warning('无法获取用户信息，请重新登录');
          return;
        }

        const response = await fetch('/sso-api/auth/sso/generate', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            secret: 'laplace-sso-shared-secret-2026-webclient-must-match',
            user_id: String(userId)
          })
        });

        const res = await response.json();
        
        // 根据实际返回的数据结构处理跳转，这里假设返回结构包含 url 字段
        if (res.code === 200 || res.success || res.url || (res.data && res.data.url)) {
          const targetUrl = res.url || (res.data && res.data.url);
          if (targetUrl) {
            window.open(targetUrl, '_blank');
          } else {
            console.log('SSO Generate Success:', res);
            this.$message.success('调用成功，请查看控制台响应');
          }
        } else {
          this.$message.error(res.message || '调用失败');
        }
      } catch (error) {
        console.error('SSO Generate Error:', error);
        this.$message.error('网络请求失败，请检查网络');
      }
    },
    // 处理下拉菜单命令
    handleCommand(command) {
      if (command === 'logout') {
        this.handleLogout();
      }
    },
    // 退出登录
    handleLogout() {
      this.$confirm('确定要退出登录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 调用退出登录接口
        this.$api.auth.logout().then(() => {
          // 清除本地存储的用户信息
          sessionStorage.removeItem('token');
          sessionStorage.removeItem('user');
          sessionStorage.removeItem('username');
          sessionStorage.removeItem('userId');
          sessionStorage.removeItem('isAdmin');
          sessionStorage.removeItem('rightList');

          // 清除 Vuex 状态
          this.$store.commit('setToken', '');
          this.$store.commit('setUser', null);
          this.$store.commit('setUsername', '');
          this.$store.commit('setUserId', '');
          this.$store.commit('setIsAdmin', false);
          this.$store.commit('setRightList', []);

          this.$message.success('退出登录成功');
          // 跳转到登录页
          this.$router.push('/login');
        }).catch(err => {
          console.error('退出登录失败:', err);
          // 即使接口调用失败，也清除本地数据并跳转
          sessionStorage.removeItem('token');
          sessionStorage.removeItem('user');
          sessionStorage.removeItem('username');
          sessionStorage.removeItem('userId');
          sessionStorage.removeItem('isAdmin');
          sessionStorage.removeItem('rightList');

          this.$store.commit('setToken', '');
          this.$store.commit('setUser', null);
          this.$store.commit('setUsername', '');
          this.$store.commit('setUserId', '');
          this.$store.commit('setIsAdmin', false);
          this.$store.commit('setRightList', []);

          this.$router.push('/login');
        });
      }).catch(() => {
        // 用户取消操作
      });
    }
  }
}
</script>

<style scoped>
.creation-center {
  height: 100vh;
  overflow: hidden;
  font-size: 16px;
}

/* 菜单图标样式统一 */
.menu-icon {
  width: 20px;
  height: 20px;
  background-size: cover;
  display: inline-block;
  vertical-align: middle;
  margin-right: 8px; /* 图标与文字间距 */
}

/* 菜单项内容容器 - 关键居中样式 */
.menu-item-content {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  text-align: center !important;
}

/* 侧边栏折叠状态样式 */
::v-deep .el-menu--collapse {
  width: 60px !important;
}

::v-deep .el-menu--collapse .el-menu-item {
  padding: 0 10px !important;
}

::v-deep .el-menu--collapse .menu-icon {
  margin-right: 0 !important; /* 折叠时去掉图标右边距 */
}

::v-deep .el-menu.el-menu--horizontal {
  border: none;
}

::v-deep .el-menu-item {
  border-radius: 40px;
  border: 1px solid #494F67 !important;
  margin-top: 10px !important;
  padding: 10px 15px !important;
  font-size: 14px;
}

::v-deep .el-menu-item.is-active {
  background-color: #6A33F0 !important;
}

/* 媒体查询 - 移动端适配 */
@media (max-width: 767px) {
  ::v-deep .el-menu-item {
    margin-top: 8px !important;
    padding: 8px 10px !important;
    font-size: 13px;
  }

  .el-main {
    padding: 10px !important;
  }
}

/* 媒体查询 - 平板及以上设备 */
@media (min-width: 768px) and (max-width: 1023px) {
  ::v-deep .el-menu-item {
    font-size: 13px;
  }
}
</style>

<style>
.content_bg{
  background-color: #404761;
}

.main_bg{
  background-color: #333A53;
}
.page {
  background-color: #232A3E;
  color: #fff;
}

::v-deep .el-input__inner {
  background-color: #333A53 !important;
  border-color: #4A4A6A !important;
  color: #fff !important;
  border-radius: 12px;
  font-size: 16px;
  height: 50px;
}

::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background: #333A53;
}

::-webkit-scrollbar-thumb {
  background: #6A33F0;
  border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
  background: #7b47ff;
}

/* 下拉菜单样式 */
::v-deep .el-dropdown-menu {
  background-color: #333A53 !important;
  border-color: #4A4A6A !important;
}

::v-deep .el-dropdown-menu__item {
  color: #fff !important;
}

::v-deep .el-dropdown-menu__item:hover {
  background-color: #404761 !important;
  color: #fff !important;
}

::v-deep .el-dropdown-menu__item i {
  color: #fff !important;
}
</style>
